



















import Vue, { VueConstructor } from 'vue';
import ErrorAlert from '@/generic/components/ErrorAlert.vue';
import { ArticleState } from '@/types/article';
export default Vue.extend({

  components: {
    ErrorAlert,
  },

  props: {
    article: Object as () => ArticleState,
  },

  updated() {
    
    this.$nextTick(function () {
      // TODO: dit draait nu te vaak. Detecteren dat het al gebeurd is of specifiek reageren op verandering van artikel-HTML.

      // Code that will run only after the entire view has been re-rendered
      // We use this because non-Vue HTML is added to the document and we want some dynamic behaviour on that as well
      // (we gebruiken requestAnimationFrame zodat de browser echt zo ver is)
      
      // (@@@ footnotes?)
    });
  },

  methods: {

  },
});

